/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react'
import { Helmet } from 'react-helmet'

const Seo = ({ description, lang, meta, title, link, customMetaLink = '' }) => {
  const metaDescription = description
  const defaultTitle = ''
  let metaLink = link
  if (lang && lang !== 'en') {
    metaLink = `https://crypto.com${link}/${lang.toLowerCase()}`
  }

  if (customMetaLink) {
    metaLink = customMetaLink
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          property: 'og:image',
          content: 'https://crypto.com/images/meta-og/listing.png',
        },
        {
          property: 'og:image:width',
          content: 1200,
        },
        {
          property: 'og:image:height',
          content: 628,
        },
        {
          property: 'og:image:alt',
          content: title,
        },
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: '',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link rel="canonical" href={metaLink} />
      <link rel="alternate" hrefLang={lang} href={metaLink} />
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
}

export default Seo
